import { render, staticRenderFns } from "./CreateOrderOther.vue?vue&type=template&id=3dca22eb&scoped=true&"
import script from "./CreateOrderOther.vue?vue&type=script&lang=js&"
export * from "./CreateOrderOther.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dca22eb",
  null
  
)

export default component.exports